import BaseService from "./BaseService";

export default class FxAllocationService extends BaseService {
    public static getFxDashboardData(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/get-pool-dashboard', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    };

    public static getFxPurchaseList(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/purchase-list', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    };

    public static getAllocationList(token: string, postData: any, isCsv = false) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/allocation-list${isCsv ? '-Csv' : ''}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static createPurchase(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/purchase', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
    public static updatePurchaseRecord(token: string, postData: any, poolId: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/purchase/' + poolId, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getLiquidityPartners(token: string, payload: any) {
        return BaseService.sendRequest(
            process.env.REACT_APP_API_URL + 'fxAllocation/get-liquidity-partner-list',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(payload)
            }
        );
    }

    public static getPayoutPartners(token: string, payload: any) {
        return BaseService.sendRequest(
            process.env.REACT_APP_API_URL + 'fxAllocation/get-payout-partner-list',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(payload)
            }
        );
    }

    public static getPoolStatusList(token: string) {
        return BaseService.sendRequest(
            process.env.REACT_APP_API_URL + 'fxAllocation/get-pool-status-list',
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': "Bearer " + token
                }
            }
        );
    }

    public static getAttachmentListByPoolId(token: string, poolId: string) {
        return BaseService.sendRequest(
            process.env.REACT_APP_API_URL + 'fxAllocation/get-fx-purchase-record-attachment/' + poolId,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': "Bearer " + token
                }
            }
        );
    }

    public static deletePurchaseRecord(token: string, poolId: string) {
        return BaseService.sendRequest(
            process.env.REACT_APP_API_URL + 'fxAllocation/purchase/' + poolId,
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': "Bearer " + token
                }
            }
        );
    }
}

